<template>
  <div class="app-modal-wrap">
    <button @click="openModal" class="btn btn-danger app-btn-alt">
      Spread The Word
    </button>

    <vodal
      :show="show"
      :width="410"
      :height="250"
      animation="zoom"
      @hide="closeModal"
    >
      <div class="app-modal">
        <p class="modal-title">Help Us Spread the Word</p>

        <p class="socials">
          <span class="social">
            <a
              href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fdonate.rubies.ng&text=To%20support%20those%20who%20have%20been%20put%20into%20difficult%20economic%20situations,%20due%20to%20COVID-19,%20make%20a%20donation%20via"
              target="_blank"
            >
              <svg
                class="twitter"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                  fill="#1DA1F2"
                ></path>
                <path
                  d="M33.4701 54.4003C46.7588 54.4003 54.0184 43.3781 54.0184 33.825C54.0184 33.512 54.0184 33.2004 53.9973 32.8903C55.4108 31.8662 56.6309 30.5982 57.6004 29.1457C56.2823 29.7305 54.8841 30.114 53.4524 30.2835C54.9603 29.3803 56.0891 27.9594 56.6289 26.2851C55.2112 27.1275 53.6603 27.7211 52.043 28.0404C49.8043 25.6564 46.2466 25.0729 43.3653 26.6172C40.484 28.1616 38.9959 31.4496 39.7357 34.6371C33.928 34.3453 28.5172 31.5979 24.8503 27.0789C22.9326 30.3834 23.9118 34.6114 27.0862 36.7335C25.9369 36.6994 24.8127 36.3889 23.8084 35.8284C23.8084 35.858 23.8084 35.889 23.8084 35.92C23.8093 39.3623 26.2326 42.3271 29.6023 43.0087C28.5391 43.2991 27.4235 43.3415 26.3414 43.1328C27.2875 46.0785 29.9988 48.0965 33.0885 48.1546C30.5312 50.1671 27.3721 51.2596 24.1196 51.2563C23.545 51.2552 22.9709 51.2204 22.4004 51.152C25.703 53.2742 29.5459 54.3999 33.4701 54.3946"
                  fill="white"
                ></path>
              </svg>
            </a>
          </span>
          <span class="social">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https://donate.rubies.ng&quote=To support those who have been put into difficult economic situations, due to COVID-19, make a donation via donate.rubies.ng."
              target="_blank"
            >
              <svg
                class="facebook"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M80 40C80 17.9062 62.0938 0 40 0C17.9062 0 0 17.9062 0 40C0 59.9688 14.625 76.5156 33.75 79.5156V51.5625H23.5938V40H33.75V31.1875C33.75 21.1641 39.7188 15.625 48.8594 15.625C53.2344 15.625 57.8125 16.4062 57.8125 16.4062V26.25H52.7656C47.7969 26.25 46.25 29.3359 46.25 32.5V40H57.3438L55.5703 51.5625H46.25V79.5156C65.375 76.5156 80 59.9688 80 40Z"
                  fill="#1877F2"
                ></path>
                <circle cx="40" cy="40" r="40" fill="#1877F2"></circle>
                <path
                  d="M49.0889 42.0134L50.1254 35.1882H43.6414V30.761C43.6414 28.8933 44.5455 27.0716 47.4496 27.0716H50.3994V21.261C50.3994 21.261 47.7236 20.7998 45.1665 20.7998C39.8241 20.7998 36.3355 24.0695 36.3355 29.9862V35.1882H30.3994V42.0134H36.3355V58.5139C37.5273 58.703 38.7464 58.7998 39.9885 58.7998C41.2305 58.7998 42.4496 58.703 43.6414 58.5139V42.0134H49.0889Z"
                  fill="white"
                ></path>
              </svg>
            </a>
          </span>
          <span class="social">
            <a @click="copySocialMessageToClipboard">
              <svg
                class="copy"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M80 40C80 17.9062 62.0938 0 40 0C17.9062 0 0 17.9062 0 40C0 59.9688 14.625 76.5156 33.75 79.5156V51.5625H23.5938V40H33.75V31.1875C33.75 21.1641 39.7188 15.625 48.8594 15.625C53.2344 15.625 57.8125 16.4062 57.8125 16.4062V26.25H52.7656C47.7969 26.25 46.25 29.3359 46.25 32.5V40H57.3438L55.5703 51.5625H46.25V79.5156C65.375 76.5156 80 59.9688 80 40Z"
                  fill="#1877F2"
                ></path>
                <circle cx="40" cy="40" r="40" fill="#DB3A3A"></circle>
                <g filter="url(#filter0_d)">
                  <path
                    d="M53.5692 39.0351L47.7542 44.8483C44.5448 48.0596 39.3383 48.0596 36.1283 44.8483C35.6226 44.3441 35.2271 43.7759 34.8797 43.1901L37.5816 40.4884C37.7101 40.3588 37.8687 40.2846 38.0202 40.1972C38.207 40.8354 38.5331 41.4396 39.035 41.9415C40.6378 43.5456 43.2459 43.5434 44.8478 41.9415L50.661 36.1285C52.2651 34.5246 52.2651 31.9171 50.661 30.3144C49.0591 28.7118 46.4516 28.7118 44.8478 30.3144L42.7806 32.3838C41.1031 31.7307 39.2958 31.5551 37.5364 31.8129L41.9414 27.408C45.1527 24.1973 50.3579 24.1973 53.5692 27.408C56.779 30.6186 56.779 35.8246 53.5692 39.0351ZM38.1969 48.5939L36.1282 50.6633C34.5255 52.2652 31.9173 52.2652 30.3143 50.6633C28.7115 49.0592 28.7115 46.4517 30.3143 44.8483L36.1282 39.0351C37.7322 37.4314 40.3387 37.4314 41.9413 39.0351C42.4421 39.536 42.7685 40.1401 42.9571 40.7774C43.1095 40.6889 43.2661 40.6169 43.3945 40.4883L46.0962 37.7877C45.7511 37.1995 45.3535 36.6334 44.8477 36.1287C41.6385 32.9179 36.4315 32.9179 33.2208 36.1287L27.4078 41.9419C24.1974 45.1535 24.1974 50.358 27.4078 53.5694C30.6185 56.7791 35.8243 56.7791 39.0349 53.5694L43.4411 49.1636C41.6807 49.423 39.873 49.2459 38.1969 48.5939Z"
                    fill="white"
                  ></path>
                </g>
                <defs>
                  <filter
                    id="filter0_d"
                    x="16"
                    y="18"
                    width="48.9766"
                    height="48.9767"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="4.5"></feGaussianBlur>
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    ></feColorMatrix>
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow"
                    ></feBlend>
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow"
                      result="shape"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>
            </a>
          </span>
          <span class="social">
            <a
              href="https://api.whatsapp.com/send?text=To support those who have been put into difficult economic situations, due to COVID-19, make a donation via donate.rubies.ng."
              target="_blank"
            >
              <svg
                class="whats-app"
                viewBox="0 0 71 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="35.625"
                  cy="35.25"
                  r="35.25"
                  fill="#48D38A"
                ></circle>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M31.6908 27.0851C31.3391 26.1499 30.9329 26.2166 30.6625 26.2064C30.3919 26.1964 30.1549 26.2014 29.7893 26.2073C29.4799 26.2123 28.9732 26.292 28.5313 26.737C28.0889 27.1811 26.8493 28.2493 26.7636 30.5133C26.6784 32.777 28.2568 35.0263 28.4772 35.3411C28.6975 35.6571 31.4912 40.5637 36.1348 42.5817C40.7789 44.5991 40.8032 43.9842 41.6551 43.9391C42.5078 43.8945 44.4405 42.9277 44.8677 41.8683C45.2949 40.8089 45.3292 39.8879 45.2205 39.6914C45.1118 39.4956 44.8075 39.3684 44.3525 39.1215C43.8969 38.8742 41.6605 37.6764 41.2411 37.5069C40.8214 37.3381 40.5154 37.2502 40.1887 37.6993C39.8619 38.1471 38.9341 39.1503 38.6529 39.4475C38.3704 39.7448 38.0986 39.7724 37.6431 39.5243C37.1889 39.2776 35.7128 38.7358 34.0011 37.1031C32.6693 35.8328 31.7951 34.2915 31.5417 33.8213C31.2882 33.3508 31.54 33.1107 31.7812 32.8906C31.9974 32.6918 32.2649 32.3702 32.5073 32.1102C32.7484 31.8502 32.8335 31.6618 32.9996 31.3601C33.1654 31.059 33.0988 30.7875 32.9912 30.5531C32.8836 30.3187 32.0423 28.0202 31.6908 27.0851Z"
                  fill="white"
                ></path>
                <path
                  d="M35.8355 19.6429C39.9855 19.6429 43.8861 21.2453 46.8184 24.1549C49.7452 27.059 51.3571 30.919 51.3571 35.0236C51.3571 39.1278 49.7452 42.9877 46.8184 45.892C43.8859 48.8018 39.9853 50.4045 35.8355 50.4045C33.2086 50.4045 30.6125 49.7419 28.3276 48.4883L27.3351 47.9438L26.2563 48.2865L21.181 49.8988L22.7812 45.1789L23.1774 44.0102L22.5356 42.9561C21.0826 40.5694 20.3146 37.8264 20.3146 35.0236C20.3146 30.919 21.9266 27.059 24.8535 24.1548C27.7858 21.2453 31.6859 19.6429 35.8355 19.6429ZM35.8355 17C25.8044 17 17.6718 25.0691 17.6718 35.0236C17.6718 38.4287 18.6242 41.6135 20.2782 44.3304L17 54L27.0564 50.8053C29.6586 52.2328 32.6514 53.0472 35.8355 53.0472C45.8678 53.0472 54 44.977 54 35.0236C54 25.0691 45.8678 17 35.8355 17Z"
                  fill="white"
                ></path>
              </svg>
            </a>
          </span>
          <span class="social">
            <a
              href="mailto:my.email@example.com?&subject=To support those who have been put into difficult economic situations, due to COVID-19, make a donation via donate.rubies.ng."
              target="_blank"
            >
              <svg
                class="mail"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 71 71"
                fill="none"
              >
                <circle cx="35.8" cy="35.3" r="35.3" fill="#DB3A3A" />
                <path
                  d="M49.8 23H21.5C20.5 23 20 23.6 20 24.5V25.3C20 25.5 20.1 25.6 20.2 25.7L35.3 35.3C35.5 35.5 35.9 35.5 36.1 35.3L51.1 25.5C51.2 25.4 51.3 25.3 51.3 25.1V24.5C51.3 23.6 50.8 23 49.8 23Z"
                  fill="white"
                />
                <path
                  d="M50.9 28.7L36.3 38.2C36.1 38.3 36 38.4 35.7 38.4 35.4 38.4 35.3 38.3 35.1 38.2L20.4 28.9C20.2 28.8 20 28.9 20 29.1V45C20 45.9 20.5 46.5 21.5 46.5H49.8C50.8 46.5 51.3 45.9 51.3 45V28.9C51.3 28.7 51.1 28.6 50.9 28.7Z"
                  fill="white"
                />
              </svg>
            </a>
          </span>
        </p>
      </div>
    </vodal>
  </div>
</template>

<script>
export default {
  name: "SocialShareModal",
  data() {
    return {
      show: false,
      socialMessage:
        "To support those who have been put into difficult economic situations, due to COVID-19, make a donation via donate.rubies.ng.",
      socialTweet:
        "To%20support%20those%20who%20have%20been%20put%20into%20difficult%20economic%20situations,%20due%20to%20COVID-19,%20make%20a%20donation%20via",
      socialTweetLink: `https://donate.rubies.ng`,
      socialTweetBackup:
        "https://twitter.com/intent/tweet?url=https%3A%2F%2Fdonate.rubies.ng&text=Contribute%20to%20Rubies%20COVID-19%20Fund%20to%20help%20the%20needy."
    };
  },
  methods: {
    copySocialMessageToClipboard() {
      this.$clipboard(this.socialMessage);
      const notification = {
        type: "success",
        message: `Copied!`
      };
      this.$store.dispatch("notification/add", notification, { root: true });
    },
    openModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    }
  }
};
</script>

<style scoped></style>
